module.exports = __webpack_public_path__ + "static/img/image_porn.72e8ea4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/solution/panels/img/intro/image_porn.jpg
// module id = xIfC
// module chunks = 0